<template>
  <v-container fill-height>
    <v-layout justify-center align-center>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

export default {
  mounted() {},
  watch: {
    loggingIn() {
      if (this.user) {
        if (this.$route.params.to) {
          this.$router.push(this.$route.params.to);
        } else {
          this.$router.push("/home");
        }
      } else {
        this.$router.push("/login");
      }
    }
  },
  computed: mapState({
    loggingIn: state => state.userState.isLoggingIn,
    user: state => state.user
  })
};
</script>